/**
 * CommentCreateRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CommentCreateRes
 */
export interface CommentCreateRes {
  /** 创建的评论ID */
  id?: string
}

/**
 * CommentCreateRes Schema
 */
export const CommentCreateResSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '创建的评论ID',
      format: 'string',
      type: 'string',
      label: '创建的评论ID',
    },
  },
  type: 'object',
}
